const {
  VITE_API_URL,
  VITE_API_KEY,
  VITE_AUTH_URL,
  VITE_CLARITY_ID,
  VITE_LOGOUT_URL,
  VITE_AUTH_SCOPE,
  VITE_SENTRY_DSN,
  VITE_GA_GTAG_ID,
  VITE_GCP_API_AUTH,
  VITE_AUTH_CLIENT_ID,
  VITE_REPORT_API_KEY,
  VITE_REPORT_API_URL,
  VITE_BUCKET_ARQUIVOS_PDF,
} = import.meta.env;

export const appEnv = {
  apiURL: VITE_API_URL,
  apiKey: VITE_API_KEY,
  authUrl: VITE_AUTH_URL,
  logoutUrl: VITE_LOGOUT_URL,
  authGCP: VITE_GCP_API_AUTH,
  clarityId: VITE_CLARITY_ID,
  sentryDSN: VITE_SENTRY_DSN,
  authScope: VITE_AUTH_SCOPE,
  analyticsId: VITE_GA_GTAG_ID,
  reportApiURL: VITE_REPORT_API_URL,
  reportApiKey: VITE_REPORT_API_KEY,
  authClientId: VITE_AUTH_CLIENT_ID,
  bucketPdf: VITE_BUCKET_ARQUIVOS_PDF,
};
